import { useEffect, useRef } from 'react'

declare global {
  interface Window {
    Zeffy?: {
      embed?: {
        init: () => void
      }
    }
  }
}

const FORM_URL = '/embed/donation-form/donate-to-make-a-difference-3969'

export default function ZeffyDonationPanel() {
  const embedRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const embed = embedRef.current
    const script = document.getElementById('zeffy-embed-script')

    const labelFrame = () => {
      embed?.querySelector('iframe')?.setAttribute(
        'title',
        'Donate to Unique Diamond Horse Sanctuary through Zeffy',
      )
    }

    const initializeEmbed = () => {
      window.Zeffy?.embed?.init()
      window.requestAnimationFrame(labelFrame)
    }

    const observer = new MutationObserver(labelFrame)
    if (embed) observer.observe(embed, { childList: true, subtree: true })

    initializeEmbed()
    script?.addEventListener('load', initializeEmbed, { once: true })

    return () => {
      observer.disconnect()
      script?.removeEventListener('load', initializeEmbed)
    }
  }, [])

  return (
    <div className="zeffy-inline-shell">
      <div
        ref={embedRef}
        className="zeffy-inline-embed"
        data-zeffy-embed
        data-form-url={FORM_URL}
        data-min-height="520"
        aria-label="Secure Zeffy donation form"
      />
    </div>
  )
}
